import { Text } from '@podiumhq/design-system';

import { formatBusinessCountryName } from 'components/BusinessDetails/utils';
import { confirmDetailsTextStyles } from '../styles';

const AddressContent = ({
  address = '',
  city = '',
  country = '',
  state = '',
  zip = '',
}) => (
  <>
    <Text {...confirmDetailsTextStyles}>{address}</Text>
    <Text {...confirmDetailsTextStyles}>
      {`${city}, ${state?.toUpperCase()} ${zip}`}
    </Text>
    <Text {...confirmDetailsTextStyles}>
      {formatBusinessCountryName(country)}
    </Text>
  </>
);

export default AddressContent;
